<template>
  <div class="isMember">
    <div class="flex space-between">
      <div class="member-header">
        <div class="header-box">
          <el-input
            placeholder="请输入会员手机号/身份证/姓名/备注"
            v-model="memberMsg"
            @focus="handleFocus"
            @blur="hideBox"
            :clearable='true'
            @clear="clearMember"
            maxlength="18"
            prefix-icon="el-icon-search"
          />
          
        </div>
        <el-button class="search-button" @click="selectMember">搜索会员</el-button>
      </div>
      <!-- 不需要搜索历史 -->
      <div class="member-box" v-if="false">
        <div class="list" v-if="list.memberList.length > 0">
          <p class="ptb10 fontSize16">会员信息</p>
          <div class="plrb10 jishi" v-if="list.tipsContent">
            {{list.tipsContent}}
          </div>
          <div class="member-auto">
            <div class="isYuanjian" v-for="(item,index) in list.memberList" :key="index" @click="clickMember(item)">
              <div class="flex-row">
                <el-avatar :src="item.headImgUrl" v-if="item.headImgUrl"></el-avatar>
                <el-avatar :src="headImgs" v-else></el-avatar>
                <div class="msg ml10">
                  <p class="fontSize16 fb">{{ item.nickName?item.nickName:item.realName }}</p>
                  <div class="flex fontSize14 pt10 color666">
                    <p class="">{{ item.mobile ? '手机号码：' : '身份证号码：'}}&nbsp;&nbsp;{{ item.mobile ? item.mobile : item.idCardNo}}</p>
                    <p class="ml20">可用余额: ￥{{ item.walletAmount }}元&nbsp;&nbsp;<span v-if="integral ? true : false">可用积分: {{Math.floor(item.integralAmount)}}</span></p>
                  </div>
                  <p class="fontSize14 pt10 color666">来源门店: &nbsp;&nbsp;{{ item.shopName }}</p>
                  <p class="fontSize14 pt10 color666" v-if="item.memberRemark">备注标签: &nbsp;&nbsp;{{ item.memberRemark }}</p>
                </div>
              </div>
<!--              <div class="member-box-yuanjian" v-if="item.yuanjianVipCardList && item.yuanjianVipCardList.length > 0"> -->
<!--                <div class="member-box-yuanjian-list" v-for="(it,index) in item.yuanjianVipCardList" :key="index">
                  <span class="point"></span> <span>{{it.storeValueName}}: {{it.surplusMoney}}99999元</span> -->
                  <!-- <button class="member-box-btn" @click="swivelClamp(item)">转卡</button> -->
                <!-- </div> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div class="no-result" v-else>
          <p>暂无搜索结果</p>
          <p class="bind-member-active" v-if="list.registerBtnFlag" @click="addClick">注册会员</p>
        </div>
      </div>
      <div class="member-box" v-if="focusHide && historyMobileList.length > 0">
        <div class="p10 history-box">
          <p>历史记录</p>
          <div class="flex-row">
            <div v-for="(item,index) in historyMobileList" :key="index">
              <!-- <el-button
                class="mt10 history-btn"
                @click="handleHistory(item)"
              >{{ item }}</el-button> -->
              <div class="not-btn">
                <el-button :key="index" class="mt10 history-btn" @click="handleHistory(item)">{{ item }}</el-button>
                <span
                  @click="removeShopBox(index,item)"
                  class="close-button el-icon-circle-close"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" :value="memberMsg" @change="editChange"></edit-set>
    <yuan-jian ref="yuanJianForm" @change="yuanJianChange"></yuan-jian>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import editSet from "../member/edit.vue";
import yuanJian from "./yuanjian.vue"
export default {
  mixins: [minxin],
  components: { editSet , yuanJian},
  props: {
    mobile: {
      type: String,
      default: null
    },
    pageName: {
      type: String,
      default: null
    },
    integral: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      dialogVisible: false,
      codeName: true,
      memberHide: false, //false
      inputHide: true,
      memberMsg: "",
      list: [],
      headImg: require("../../assets/images/headerImg.png"),
      headImgs: require("../../assets/images/new/searchMore.png"),
      focusHide: false,
      historyMobileList: [],
      listRow: {}
    };
  },
  created() {
    if (this.mobile) {
      this.memberMsg = this.mobile;
      this.selectMember();
      // this.clickMember(this.list);
    }
  },
  watch: {
    mobile (o) {
      if (o) {
        this.memberMsg = this.mobile;
        this.selectMember();
        // this.clickMember(this.list);
      }
    }
  },
  methods: {
    addClick() {
        // 注册会员
        this.$refs["editSetForm"].$emit("set", null)
    },
    editChange(bool) {
      if (bool) {
        this.selectMember();
      }
    },
    changeInputValue(value) {
      this.memberMsg = value;
      if (this.memberMsg.length > 0) {
        this.selectMember();
        this.focusHide = false;
      }
    },
    handleFocus(value) {
      this.memberHide = false;
      let arr = JSON.parse(localStorage.getItem("historyMobileList"));
      console.log('数据：',arr);
      if (arr) {
        this.historyMobileList = arr;
      }
      this.focusHide = true;
    },
    hideBox() {
      setTimeout(() => {
        this.focusHide = false;
      }, 300);
    },
    removeShopBox(index, value) {
      let arr = [];
      if (JSON.parse(localStorage.getItem("historyMobileList"))) {
          arr = JSON.parse(localStorage.getItem("historyMobileList"));
      }
      arr.splice(index, 1);
      localStorage.setItem("historyMobileList", JSON.stringify(arr));
      this.historyMobileList = arr;
      if (this.historyMobileList.length > 0) {
        this.focusHide = true;
      }else {
        this.focusHide = false;
      }
    },
    handleHistory(msg) {
      this.changeInputValue(msg);
    },
    handleInputHide() {
      this.memberHide = false;
      this.inputHide = true;
      this.memberMsg = "";
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
      this.$emit("handleUser", "");
    },
    clickMember(list) {
      this.memberHide = false;
      this.inputHide = false;
      console.log(list)
      if (this.memberMsg) {
        this.$store.commit("setMemberMobile", this.memberMsg);
      }
      this.listRow = list;
      
      this.$emit("handleChange", list.id);
      this.$emit("handleUser", list);
    },
    clearMember() {
      this.memberHide = false;
      this.focusHide = false;
      this.inputHide = true;
      this.memberMsg = ""
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
    },
    selectMember() {
      if (this.memberMsg.length == 0) return this.$emit('handleChange', 0)
      this.$api.get(this.$url.member.search, {
          keyword: this.memberMsg,
          needIntegralFlag: this.integral ? true : false
        })
        .then(res => {
          if (res) {
            this.$store.commit("setMemberMobile", this.memberMsg);
            this.list = res;
            this.memberHide = true;
            this.$emit('handleChange', this.memberMsg);
          } else {
            this.list = res;
            this.memberHide = true;
          }
          // setTimeout(() => {
          //   this.memberHide = false;
          // }, 3000)
          if (res.memberList.length == 0) {
            // this.memberHide = false;
            // this.$emit("handleChange", "");
          }
        })
        .catch(error => {});
    },
    swivelClamp (row) {
      // 转卡
      let obj = {
        cardList: row,
        form: this.list
      }
      this.$refs["yuanJianForm"].$emit("open", obj)
    },
    yuanJianChange (org) {
      if (org) {
        this.selectMember();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.isMember {
  position: relative;
  width: 100%;
  border-radius: 10px;
  // background: #fff;
}
.member-header {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  .header-box {
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }
  .search-button {
    position: absolute;
    top: 0;
    right: -94px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    background: #3388FF;
  }
  /deep/ .el-input__inner {
    height: 40px;
  }
}
.ptb10 {
  padding: 10px;
}
.member-box {
  width: 100%;
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 99;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px rgba(31,47,67,0.2000);
  box-sizing: border-box;
  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #646566;
    height: 120px;
    p {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .bind-member-active {
      margin-left: 5px;
      margin-top: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .history-box {
    padding: 10px;
  }
  .history-btn {
    margin-top: 10px;
    margin-right: 10px;
  }
  .not-btn {
    position: relative;
    display: inline-block;
    /deep/ .el-button.is-disabled {
      background: #fff;
      border-color: #c6e2ff;
      color: #409eff;
    }
  }
  .close-button {
    position: absolute;
    right: 0;
    top: -1px;
    color: #999;
    font-size: 20px;
    cursor: pointer;
  }
}
.list {
  .isYuanjian {
    padding: 10px;
    margin: 0 10px 10px;
    border: 1px solid #EEE;
    border-radius: 8px;
  }
  .flex-row {
    cursor: pointer;
    display: flex;
    align-items: center;
    
    
    .msg {
      margin-left: 10px;
    }
    &:hover {
      background-color: #F3F8FE;
    }
    
  }
  .member-box-yuanjian {
    display: flex;
    flex-wrap: wrap;
    margin: 5px 10px 0 50px;
    border-top: 1px solid #eee;
    padding-top: 10px;
    font-size: 14px;
    color: #666;
    .member-box-yuanjian-list {
      width: calc(50% - 20px);
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
      .point {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #EEE;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
.member_bg {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  border-radius: 10px;
  .flex-row {
    align-items: center;
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .icons {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      color: @blue;
    }
  }
}
.flex {
  display: flex;
}
.toggleMember {
  width: 99px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  font-size: 14px;
  color: #3388FF;
  background: #FFF;
  border: 1px solid #EEE;
  border-radius: 18px;
  .toggleMember-img {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    img {
      margin-top: -1px;
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
.member-auto {
  min-height: 1px;
  max-height: 600px;
  overflow: auto;
}
</style>